module.exports = __webpack_public_path__ + "img/q-9-1@2x.1ba93978.png";